import React, { useEffect, useState } from "react";
import { css } from "@emotion/react";
import { NumberInput } from "@editor/components";

export type IToolbarNumberInputProps = {
  prefix?: string;
  label?: string;
  type: string;
  onChange?: (value: any) => void;
  value?: any;
};

export const ToolbarNumberInput = ({
  onChange,
  value,
  prefix,
  label,
  type,
  ...props
}: IToolbarNumberInputProps) => {
  const [internalValue, setInternalValue] = useState(value);
  const [active, setActive] = useState(false);

  return (
    <div
      style={{ width: "100%", position: "relative" }}
      onClick={() => {
        setActive(true);
      }}
    >
      <NumberInput
        value={value || ""}
        // onKeyDown={(e) => {
        //   if (e.key === "Enter") {
        //     onChange?.((e.target as any).value);
        //   }
        // }}
        onChange={(value:any) => {
          setInternalValue(value);
          onChange?.(value);
        }}
        {...props}
      />
    </div>
  );
};
